import { useQuery } from '@tanstack/react-query';
import { getTenantFeatures } from '../../api/queries';

export const useGetTenantFeaturesQuery = (tenantId: number | null) => {
  return useQuery({
    queryKey: ['GET_TENANT_FEATURES', tenantId],
    queryFn: () => getTenantFeatures(tenantId!),
    enabled: !!tenantId,
    staleTime: 1 * 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
